mainApp.directive('monitorLastMile', function() {
    return {
            templateUrl: '/public/directives/charts/monitorLastMile.html',
            scope: {
                pid : '='
            },
    controller: ['$scope', 'ChartsService', '$state','$rootScope','DateRangeService',
      function ($scope, ChartsService, $state, $rootScope, DateRangeService) {
        $scope.monitoredInterfaces = [];
        $scope.LMMSupportedForSite = true;

         $scope.roles = {
                wan_1: 'WAN 1',
                wan_2: 'WAN 2',
                wan_3: 'WAN 3',
            };

        var SAMPLES = 60;
        var MIN_INTERVAL = 2 * 60 * 1000;
        var DEFAULT_MAX_PERCENT = 20;
        var defaultChartSettings = ChartsService.getCommonSerialChartSettings({
           type: "serial",
           legend: {
            valueAlign: "left",
            valueFunction: function(){return ""}
           },
           graphs: destGraphs,
           allLabels: [{
             text: "Latency",
             align: "center",
             bold: true,
             size: 13,
             y: 10
           }],
           chartCursor: {
               cursorPosition: "mouse",
               selectWithoutZooming: true,
               zoomable: true,
               listeners: [{
                     event: "moved",
                     method: handleMoved
                   }, {
                     event: "onHideCursor",
                     method: handleHide
                   }]
           },
           marginTop: 50,
            listeners: [{
               event: "init",
               method: afterInit
           }],
           dataProvider :[]
       });

        var charts = [];

        //all destinations
        var destinations = [];
        var destGraphs = [];

        //results from server in charts format
        var lastMileRtt;
        var lastMilePacketLoss;

        //on page init
        init();

        function handleZoom (event) {
 				var start = Math.min(event.start, event.end);
 				var end = Math.max(event.start, event.end);
 				if (start && end && (end - start) > MIN_INTERVAL * 3) {
 					DateRangeService.zoomTo(start, end, calcInterval(start, end), false);
 				}
         }

        function handleMoved(e){
          syncCursors(e);
        }

        function handleHide(e){
          hideCursors(e);
        }

        function syncCursors(e) {
          for(var i = 0; i < charts.length; i++) {
            if(charts[i] !== e.chart) {
              charts[i].chartCursor.syncWithCursor(e.chart.chartCursor);
            }
          }
        }

        function hideCursors(e) {
          for(var i = 0; i < charts.length; i++) {
            if(charts[i] !== e.chart) {
              charts[i].chartCursor.hideCursor();
              charts[i].chartCursor.clearSelection();
            }
          }
        }


        function init(){
            store.fetch({
                path: 'isLMMSupportedForSite',
                queryParams: { accountId: $state.params.accountId,
                               siteProtoId: $scope.pid,
                               },
                success: function (data) {
                $scope.LMMSupportedForSite = data;
                    if(data === true) {
                       getInterfacesAndDrawCharts();
                    }
                }
            });
        };

        function getInterfacesAndDrawCharts() {

        store.fetch({
              method : 'GET',
              url : 'getInterfacesAndDestinations',
              queryParams: { accountId: $state.params.accountId,
                            siteProtoId: $scope.pid
                         },
              success: function(data) {
                   $scope.monitoredInterfaces = data.monitoredInterfaces;
                   $scope.configuredDestinations = data.destinations;
                   $scope.$digest();

                  if($scope.monitoredInterfaces && $scope.monitoredInterfaces.length > 0) {
                    destinations = data.destinations;

                    //get last mile stats from server
                    getStats($rootScope.dateRange.start, $rootScope.dateRange.end);
                  }
                  else {
                    $scope.monitoredInterfaces = null;
                  }
              }
          });
      }

        //create packet loss and rtt charts for each interface
        function makeCharts(){

          destinations.forEach(function(dest){
            var interval = calcInterval ($rootScope.dateRange.start, $rootScope.dateRange.end)
            destGraphs.push({valueField: dest, title: dest, gapPeriod: interval/1000 + 1, forceGap:true})
          });

          defaultChartSettings.graphs = destGraphs;

          $scope.monitoredInterfaces.forEach(function(inter){
                makeRttChart(inter);
                makePacketLossChart(inter);
            });
    }

        function afterInit(chart) {
             chart = chart.chart;
             chart.chartCursor.addListener("selected", handleZoom);

             chart.chartCursor.addListener("onShowCursor", function (event) {
                 event.chart.chartDiv.style.cursor = "zoom-in";
             });

             chart.chartCursor.addListener("onHideCursor", function (event) {
                 event.chart.chartDiv.style.cursor = "default";
             });
        }

        //create rtt chart to given interface
        function makeRttChart(inter){
            var chartsSettings = angular.copy(defaultChartSettings);
            chartsSettings. allLabels = [{
                                   text: "Latency",
                                   align: "center",
                                   bold: true,
                                   size: 13,
                                   y: 10
                                 }];

            chartsSettings.valueAxes= [{labelFunction: function (value){ return value + ' ms'}, minPeriod:'ss'}];

            if(lastMileRtt && lastMileRtt[inter.interface_id]) {
                   chartsSettings.dataProvider = lastMileRtt[inter.interface_id].sort(timestampSort);
            }

           chartsSettings.dataProvider = getDataWithoutGaps(chartsSettings.dataProvider);
           charts.push(AmCharts.makeChart('rttChart-' + inter.interface_id , chartsSettings));
    }

        //create pl chart to given interface
        function makePacketLossChart(inter){
        var chartsSettings = angular.copy(defaultChartSettings);
            chartsSettings.allLabels = [{
                            text: "Packet Loss",
                            align: "center",
                            bold: true,
                            size: 13,
                            y: 10
                            }];
            chartsSettings.precision = 2;
            chartsSettings.valueAxes = [{
                                        labelFunction: function (value){ return value + '%'},
                                            minPeriod:'ss'
                                        }];

            if(lastMilePacketLoss && lastMilePacketLoss[inter.interface_id]) {
                chartsSettings.dataProvider = lastMilePacketLoss[inter.interface_id].sort(timestampSort);
            }

            var maxValue = DEFAULT_MAX_PERCENT;

            //set value axis maximum according to max (max sample , default max)
            if(chartsSettings.dataProvider.length > 0) {
            chartsSettings.graphs.forEach(function (graph) {
                            maxValue = Math.max(maxValue, _.max(chartsSettings.dataProvider, graph.valueField)[graph.valueField]);
                        });
            }
            chartsSettings.valueAxes[0].maximum = maxValue;

            chartsSettings.dataProvider = getDataWithoutGaps(chartsSettings.dataProvider);
            charts.push(AmCharts.makeChart('packetLossChart-' + inter.interface_id , chartsSettings));
    }

        //add missing timestamps with no data
        function getDataWithoutGaps(dataProvider) {
            var dataWithoutGaps = [];

           for(let i = $rootScope.dateRange.start ; i < $rootScope.dateRange.end; i = i + calcInterval($rootScope.dateRange.start, $rootScope.dateRange.end ) ){
                let a = dataProvider.filter(function(sample){return sample.timestamp == i;});
                if(a.length == 0 ) {
                    dataWithoutGaps.push({
                       timestamp : i
                    })

                } else {
                    dataWithoutGaps.push(a[0]);
                }
            }

            return dataWithoutGaps;
        }

        //get last mile stats data from server
        function getStats(fromDate, toDate, interval) {

        var interval = calcInterval(fromDate , toDate);

        store.fetch({
            path: 'getLastMileMonitoringStats',
            queryParams: { accountId: $state.params.accountId,
                           siteProtoId: $scope.pid,
                           fromDate: fromDate,
                           toDate:toDate,
                           interval: interval
                           },
            success: function (data) {

                if(data.items.length) {
                    prepareDataForCharts(data);
                }
                else {
                    // in this case we're making charts from configuration, with no data
                }

                makeCharts();
            }
            });
        }

        //change data structure to align with charts (destinations as keys)
        function prepareDataForCharts (data) {
            data.items.forEach(function (item){
                var interfaceId = item.device.interfaceName;

                if (!lastMileRtt || !lastMilePacketLoss){
                    lastMileRtt = {};
                    lastMilePacketLoss = {};
                }

                lastMileRtt[interfaceId]= [];
                lastMilePacketLoss[interfaceId] = [];

                //add stats by time stamp to each data type
                Object.keys(item.lastMileData.destinationStats).forEach(function (timestamp) {
                    let intTimestamp = parseInt(timestamp, 10);

                    var rttSample = {timestamp: intTimestamp};
                    var plSample = {timestamp : intTimestamp};

                    var sample = item.lastMileData.destinationStats[timestamp];

                    Object.keys(sample).forEach(function(destination){
                        if(!destinations.includes(destination)){
                            destinations.push(destination);
                        }

                            rttSample[destination] = sample[destination].rtt;
                            plSample[destination] = sample[destination].packetLoss;
                    });

                    lastMileRtt[interfaceId].push(rttSample);
                    lastMilePacketLoss[interfaceId].push(plSample);
                });

            });
        }

        //TODO update daterangeService with bucket duration
        function calcInterval (fromDate, toDate) {
            var interval = 0;

            if(fromDate < toDate){
               interval = (toDate - fromDate) / SAMPLES;
            }

            return Math.trunc(interval > MIN_INTERVAL ? interval : MIN_INTERVAL);
        }

        //sorting chart object by timestamp
        var timestampSort = function(a, b) {
             var keyA = new Date(a.timestamp),keyB = new Date(b.timestamp);
             // Compare the 2 dates
             if(keyA < keyB) return -1;
             if(keyA > keyB) return 1;
             return 0;
         };

      }]
     };
});